import { render, staticRenderFns } from "./ChevronRightIcon.vue?vue&type=template&id=4b637d56"
import script from "./ChevronRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports